import { takeEvery, put, call } from "redux-saga/effects";

import { UPDATE_PASSWORD } from "./actionTypes";

import { updatePasswordSuccessful, updatePasswordError } from "./actions";

import { putCall } from "../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../common/constant/constantURL";

// update password
function* updatePasswordFunction({ payload: { updatePasswordObject } }) {
  try {
    var url = constClass.REST_API_UPDATE_PASSWORD;
    var responsJSON = yield call(putCall, url, updatePasswordObject);
    yield put(updatePasswordSuccessful(responsJSON));
  } catch (error) {
    yield put(updatePasswordError(error));
  }
}

function* updatePasswordSaga() {
  yield takeEvery(UPDATE_PASSWORD, updatePasswordFunction);
}

export default updatePasswordSaga;
